module.exports = __webpack_public_path__ + "static/media/buildingConstruction1.4055b2ac.jpg";